import { Link } from "react-router-dom";
import SearchBar from "@/components/feature/SearchBar";

const hotKeywords = ["悬疑", "科幻", "都市", "古装", "林知遥", "综艺"];

export default function SearchBand() {
  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 h-7 rounded-full bg-primary-100 text-primary-700 text-xs">
            <i className="ri-database-2-line" />
            影视作品 · 演员资料 · 资讯动态
          </span>
          <h1 className="mt-4 font-heading font-black text-2xl md:text-4xl text-foreground-950">
            一站式查询你关心的影视内容
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            输入影视作品名称、演员姓名或题材关键词，快速找到对应的资料与动态。
          </p>
          <div className="mt-6">
            <SearchBar size="lg" />
          </div>
          <div className="mt-4 flex items-center justify-center flex-wrap gap-2">
            <span className="text-xs text-foreground-500">热门搜索：</span>
            {hotKeywords.map((k) => (
              <Link
                key={k}
                to={`/search?q=${encodeURIComponent(k)}`}
                className="px-3 h-7 flex items-center rounded-full bg-background-50 border border-background-200 text-xs text-foreground-700 whitespace-nowrap hover:border-accent-300 hover:text-accent-600 transition-colors"
              >
                {k}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}